import api from '../api';

class DashboardService {
    async getDashboardData(): Promise<any> {
        const response = await api.get('/progress/learning-path/dashboard/');
        return response.data;
    }
}

export default new DashboardService();
